import { useQuery } from "@tanstack/react-query";
import { callAreaListingEndpoint } from "../api";
import { CountyData } from "../types";

export const useGetAreaListingData = () => {
  return useQuery<CountyData[], Error>({
    queryKey: ["area-listing"],
    queryFn: () => callAreaListingEndpoint(),
  });
};
